import { AvatarName } from "@/components";
import { BellOutlined, RollbackOutlined } from "@ant-design/icons";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import { PageContainer } from "@ant-design/pro-components";
import "@ant-design/v5-patch-for-react-19";
import { useNavigate, useParams } from "@umijs/max";
import { Badge, Button, Card, ConfigProvider, FloatButton } from "antd";
import zhCN from "antd/locale/zh_CN";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import React, { useEffect, useState } from "react";
import defaultSettings, { getSettings } from "../config/defaultSettings";
import { ProjectSelect } from "./components/RightContent/AvatarDropdown";
import { errorConfig } from "./requestErrorConfig";
import { getFormData, replacePathSegment } from "./utils/utils.js";
dayjs.locale("zh-cn");
const isDev = process.env.NODE_ENV === "development";
const loginPath = "/user/login";

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any>;
}> {
  const fetchUserInfo = async () => {
    const data: any = await axios("/api/users/me");
    if (data.ret == 0) {
      return {
        ...data?.msg,
        name: data?.msg?.nickname,
      };
    } else {
      const currentPath = window.location.pathname;
      if (currentPath !== loginPath && currentPath !== loginPath + "/") {
        window.location.href = loginPath;
      }
    }
    return undefined;
  };

  const pathName = window.location.pathname;

  if (
    ![
      loginPath,
      loginPath + "/",
      "/user/register",
      "/user/register-result",
    ].includes(pathName)
  ) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

export const layout = ({
  initialState,
  setInitialState,
}: {
  initialState?: {
    settings?: Partial<LayoutSettings>;
    currentUser?: any;
    // loading?: boolean;
    fetchUserInfo?: () => Promise<any>;
  };
  setInitialState?: (state: any) => void;
}) => {
  const currentColorPrimary = initialState?.settings?.colorPrimary || "#1890ff";
  const dynamicSettings = getSettings(currentColorPrimary);
  const [solutionList, setSolutionList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const params = useParams();
  // 添加路径处理逻辑，确保在user/login和login等路径下也能正确加载静态资源
  React.useEffect(() => {
    const path = window.location.pathname;
    // 如果路径是/user/login或/login（不带斜杠），重定向到带斜杠的路径
    if (path === "/user/login" || path === "/login") {
      window.location.href = path + "/";
    }
  }, []);

  const menuDataRender = (menuList: any[]) => {
    const pathName = window.location.pathname;
    const extractParams = () => {
      const params: { [key: string]: string } = {};
      // 使用[^/]+匹配除斜杠外的任何字符，支持包含连字符的ID
      const listSolutionsMatch = pathName.match(/\/listSolutions\/([^/]+)/);
      if (listSolutionsMatch) {
        params.id = listSolutionsMatch[1];
      }
      // 支持包含连字符的ID和solutionId
      const fixSolutionsDetailMatch = pathName.match(
        /\/fixSolutionsDetail\/([^/]+)\/([^/]+)/
      );
      if (fixSolutionsDetailMatch) {
        params.id = fixSolutionsDetailMatch[1];
        params.solutionId = fixSolutionsDetailMatch[2];
      }

      return params;
    };

    const params = extractParams();

    const replaceDynamicParams = (path: string) => {
      let newPath = path;
      Object.entries(params).forEach(([key, value]) => {
        newPath = newPath.replace(`:${key}`, value);
      });
      return newPath;
    };

    const processMenuList = (list: any[]) => {
      return list.map((route) => {
        const newRoute = { ...route };
        if (newRoute.path) {
          newRoute.path = replaceDynamicParams(newRoute.path);
        }
        if (newRoute.children) {
          newRoute.children = processMenuList(newRoute.children);
        }
        return newRoute;
      });
    };

    if (pathName.includes("listSolutions")) {
      const listSolutionsMenu = menuList.find(
        (item: any) => item.path === "/listSolutions/:id"
      );
      if (listSolutionsMenu) {
        const processedChildren = processMenuList(listSolutionsMenu.children);
        return processedChildren.filter(
          (route: any) => route.path && route.path !== "/listSolutions/:id"
        );
      }
      return [];
    }
    if (pathName.includes("fixSolutionsDetail")) {
      const fixSolutionsMenu = menuList.find(
        (item: any) => item.path === "/fixSolutionsDetail/:id/:solutionId"
      );
      if (fixSolutionsMenu) {
        const processedChildren = processMenuList(fixSolutionsMenu.children);
        return processedChildren.filter(
          (route: any) =>
            route.path && route.path !== "/fixSolutionsDetail/:id/:solutionId"
        );
      }
      return [];
    }

    const processedMenuList = processMenuList(menuList);
    return processedMenuList.filter(
      (route: any) =>
        route.path !== "/listSolutions/:id" &&
        route.path !== "/fixSolutionsDetail/:id/:solutionId"
    );
  };
  const getFixSolutionsList = () => {
    getFormData({
      page: 1,
      page_size: 999,
      constant: {
        classId: "project_plan",
      },
      filter_cond: {
        op: "and",
        filters: [{ field: "project_code", op: "=", value: params.id }],
      },
    })
      .then((res) => {
        console.log(res, "soluListres");
        setSolutionList(res?.rows);
      })
      .catch((err) => {
        console.log(err, "soluListres");
      });
  };
  useEffect(() => {
    if (params.id) {
      getFixSolutionsList();
    }
  }, [params.id, window.location.pathname]);

  return {
    ...dynamicSettings,
    // avatarProps: {
    //   src: initialState?.currentUser?.avatar,
    //   title: <AvatarName />,
    //   render: (_: any, avatarChildren: React.ReactNode) => {
    //     console.log(avatarChildren,'avatarChildren');
    //     const pathname= window.location.pathname;
    //     return <div style={{display:'flex',alignItems:'center'}}>
    //       {pathname.includes('listSolutions') && <ProjectSelect/>}
    //       <div style={{color:"#fff",fontWeight:700,marginRight:20}}>
    //       {pathname.includes('fixSolutionsDetail')&&initialState?.curProject?.name}
    //       </div>
    //       <AvatarDropdown>{avatarChildren}</AvatarDropdown>
    //     </div>;
    //   },
    // },
    onCollapse: (collapsed: boolean) => {
      setInitialState((prev) => ({
        ...prev,
        collapsed,
      }));
    },
    waterMarkProps: {
      // content: initialState?.currentUser?.name,
      content:''
    },
    onPageChange: async () => {
      setLoading(true);
      try {
        const pathName = window.location.pathname;
        console.log(pathName, loginPath, initialState, "kkl2");

        // 简化路径判断逻辑
        const isLoginPath =
          pathName === loginPath || pathName === `${loginPath}/`;
        // 未登录且不在登录页，跳转登录
        if (!initialState?.currentUser && !isLoginPath) {
          window.location.href = loginPath;
          return; // 跳转后终止后续逻辑
        }

        // 封装通用的表单查询函数，减少重复代码
        const fetchFormData = async (classId, field, value) => {
          const res = await getFormData({
            page: 1,
            page_size: 1,
            constant: { classId },
            filter_cond: {
              op: "and",
              filters: [{ field, op: "=", value }],
            },
          });
          return res?.rows?.[0];
        };

        // 收集需要执行的异步请求
        const requestList = [];
        // 项目详情请求
        if (params.id) {
          requestList.push(
            fetchFormData("project", "code", params.id).then((data) => ({
              type: "curProject",
              data,
            }))
          );
        }
        // 解决方案详情请求
        if (params.solutionId) {
          requestList.push(
            fetchFormData("project_plan", "id", params.solutionId).then(
              (data) => ({ type: "fixSolutions", data })
            )
          );
        }

        // 并行执行所有请求
        if (requestList.length > 0) {
          const results = await Promise.all(requestList);
          // 批量更新状态，减少多次 setState 触发的重渲染
          setInitialState((prev) => {
            const newState = { ...prev };
            results.forEach((item) => {
              newState[item.type] = item.data;
            });
            return newState;
          });
        }
      } catch (error) {
        console.error("页面切换请求失败:", error);
        // 可选：错误提示、兜底逻辑
      } finally {
        // 无论成功/失败，最终关闭loading
        setLoading(false);
      }
    },
    bgLayoutImgList: [
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr",
        left: 85,
        bottom: 100,
        height: "303px",
      },
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr",
        bottom: -68,
        right: -45,
        height: "303px",
      },
      {
        src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr",
        bottom: 0,
        left: 0,
        width: "331px",
      },
    ],
    menuHeaderRender: undefined,
    menuDataRender: menuDataRender,
    childrenRender: (children: React.ReactNode) => {
      const navigate = useNavigate();
      // 使用window.location获取当前路径，避免使用未定义的history对象
      const getParentPath = () => {
        const pathName = window.location.pathname;
        // 匹配 listSolutions/:id 或 fixSolutionsDetail/:id/:solutionId
        const listSolutionsMatch = pathName.match(/\/listSolutions\/([^/]+)/);
        const fixSolutionsDetailMatch = pathName.match(
          /\/fixSolutionsDetail\/([^/]+)\/([^/]+)/
        );

        if (fixSolutionsDetailMatch) {
          // fixSolutionsDetail 返回到 listSolutions（保持id不变）
          const [, id] = fixSolutionsDetailMatch;
          return `/listSolutions/${id}`;
        }
        if (listSolutionsMatch) {
          // listSolutions 返回到你定义的上一级（示例：列表首页，保持id）
          const [, id] = listSolutionsMatch;
          return `/your-parent-path/${id}`; // 替换为实际的上一级路径
        }
        return "/"; // 默认返回首页
      };

      const [pageTitle, setPageTitle] = useState(
        document.title.replace("- 环境足迹分析系统", "")
      );

      useEffect(() => {
        // 当路径变化时更新标题
        setPageTitle(document.title.replace("- 环境足迹分析系统", ""));
      }, [window.location.pathname]);

      return (
        <ConfigProvider locale={zhCN}>
          {/* ,position:'fixed',top:0,left:0,right:0,zIndex:100 */}
          <div
            style={{
              height: 55,
              backgroundColor: "#fff",
              borderBottom: "1px solid #E5E8EB",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 30px",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 100,
              paddingLeft: initialState?.collapsed ? 103 : 280,
            }}
          >
            {window.location.pathname.includes("listSolutions") && (
              <ProjectSelect />
            )}
            <div style={{ color: "#00A870", fontWeight: 700, marginRight: 20 }}>
              {window.location.pathname.includes("fixSolutionsDetail") &&
                initialState?.curProject?.name}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Badge
                dot={true}
                offset={[-20, 0]}
                style={{ backgroundColor: "#00A870" }}
              >
                <BellOutlined
                  style={{
                    marginRight: "16px",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                />
              </Badge>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderLeft: "1px solid #E5E8EB",
                  paddingLeft: 10,
                }}
              >
                <AvatarName />
              </div>
            </div>
          </div>
          <PageContainer
            style={{ paddingTop: 55 ,height:'100vh'}}
            breadcrumbRender={false}
            title={false}
            loading={loading}
          >
              {window.location.pathname.includes("fixSolutionsDetail") && (
              // <Card style={{ marginBottom: 10 }}>
                <div style={{ overflow: "auto", display: "flex" ,marginBottom:16}}>
                  {solutionList?.map((e) => {
                    return (
                      <Button
                        style={{ marginRight: 10 ,borderRadius:10,height:36}}
                        onClick={() => {
                          setLoading(true);
                          const newPath = replacePathSegment(
                            window.location.pathname,
                            2,
                            e?.id
                          );
                          navigate(newPath);
                        }}
                        // shape="round"
                        type={
                          initialState?.fixSolutions?.id === e.id
                            ? "primary"
                            : "default"
                        }
                        key={e.id}
                      >
                        {e.name}
                      </Button>
                    );
                  })}
                </div>
              // </Card>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 16,
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              <div
                style={{
                  width: 5,
                  height: 28,
                  backgroundColor: "#00A870",
                  borderRadius: 4,
                  marginRight: 16,
                }}
              ></div>
              <div>{pageTitle}</div>
            </div>
          
            {children}
          </PageContainer>
          {(window.location.pathname.includes("listSolutions") ||
            window.location.pathname.includes("fixSolutionsDetail")) && (
            <FloatButton
              onClick={() => {
                if (window.location.pathname.includes("listSolutions")) {
                  //  window.location.href = '/';
                  navigate("/");
                }
                if (window.location.pathname.includes("fixSolutionsDetail")) {
                  //  window.location.href = getParentPath();
                  navigate(getParentPath());
                }
              }}
              icon={<RollbackOutlined />}
            />
          )}
        </ConfigProvider>
      );
    },
  };
};

// 移除未使用的request配置
export const request = {
  ...errorConfig,
};
